const _excluded = ["classes", "testId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useMemo } from 'react';
import { Popover as MuiPopover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import colors from "../../foundations/colors.module.scss";
import { useDevice } from "../Device";
import { baseMenuPaperStyles } from "../Menu";
import { useOverlayContext } from "../OverlayContext";
import { jsx as _jsx } from "react/jsx-runtime";
const useStyles = makeStyles({
  paper: _objectSpread(_objectSpread({
    background: colors.dark50
  }, baseMenuPaperStyles), {}, {
    margin: 0
  })
});
function MobilePopover(_ref) {
  let {
    open,
    children,
    onClose: _onClose
  } = _ref;
  const {
    pushBottomSheetPage,
    popBottomSheetPage
  } = useOverlayContext();
  useEffect(() => {
    if (open) {
      pushBottomSheetPage({
        content: children,
        paddingBottom: 0,
        onClose: () => {
          _onClose === null || _onClose === void 0 || _onClose({}, 'backdropClick');
        }
      });
    } else {
      popBottomSheetPage();
    }
  }, [open]); // eslint-disable-line react-hooks-static-deps/exhaustive-deps

  return null;
}

/** A customized popover based on Material-UI's Popover component. */
export function Popover(props) {
  var _props$anchorOrigin, _additionalProps$anch;
  const {
      classes,
      testId
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  const overrides = useStyles();
  const {
    isMobileDevice
  } = useDevice();
  const actualClasses = useMemo(() => {
    return _objectSpread(_objectSpread({}, classes || {}), {}, {
      paper: cn(overrides.paper, classes === null || classes === void 0 ? void 0 : classes.paper)
    });
  }, [classes, overrides]);
  const additionalProps = {};
  if (!(props !== null && props !== void 0 && (_props$anchorOrigin = props.anchorOrigin) !== null && _props$anchorOrigin !== void 0 && _props$anchorOrigin.horizontal)) {
    additionalProps.anchorOrigin = {
      vertical: 'bottom',
      horizontal: 'left'
    };
  }
  if ((additionalProps === null || additionalProps === void 0 || (_additionalProps$anch = additionalProps.anchorOrigin) === null || _additionalProps$anch === void 0 ? void 0 : _additionalProps$anch.horizontal) === 'left') {
    additionalProps.transformOrigin = {
      vertical: -8,
      horizontal: 'left'
    };
  }
  return isMobileDevice ? /*#__PURE__*/_jsx(MobilePopover, _objectSpread({}, props)) : /*#__PURE__*/_jsx(MuiPopover, _objectSpread(_objectSpread({}, restProps), {}, {
    "data-testid": testId,
    classes: actualClasses
  }, additionalProps));
}